/**
 * Usage Limit Display Component
 * Shows current resource usage against plan limits
 */

import type { CheckUsageLimitResponse } from '@/types/subscription';

interface UsageLimitProps {
  usage: CheckUsageLimitResponse;
}

export function UsageLimit({ usage }: UsageLimitProps) {
  const renderUsageBar = (label: string, used: number, limit: number | null, percentage: number) => {
    const isWarning = percentage > 80 && percentage < 100;
    const isExceeded = percentage >= 100;

    return (
      <div key={label} className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-white">{label}</span>
          <span className="text-sm text-white/50">
            {used} / {limit === null ? '∞' : limit}
          </span>
        </div>
        <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all ${
              isExceeded
                ? 'bg-red-500'
                : isWarning
                  ? 'bg-yellow-500'
                  : 'bg-[#C8A96E]'
            }`}
            style={{ width: `${Math.min(percentage, 100)}%` }}
          />
        </div>
        {percentage >= 100 && (
          <p className="text-xs text-red-400 mt-1">⚠️ Limite excedido</p>
        )}
        {isWarning && (
          <p className="text-xs text-yellow-400 mt-1">⚠️ {Math.round(percentage)}% de uso</p>
        )}
      </div>
    );
  };

  return (
    <div className="bg-[#111111] border border-white/5 rounded-2xl p-6">
      <h3 className="text-lg font-semibold text-white mb-6">Uso de Recursos</h3>

      <div className="space-y-6">
        {renderUsageBar(
          '🎵 Músicas',
          usage.songs.used,
          usage.songs.limit,
          usage.songs.percentage
        )}
        {renderUsageBar(
          '👥 Times',
          usage.teams.used,
          usage.teams.limit,
          usage.teams.percentage
        )}
        {renderUsageBar(
          '👤 Membros de Time',
          usage.team_members.used,
          usage.team_members.limit,
          usage.team_members.percentage
        )}
      </div>
    </div>
  );
}
